// ============================================
// Access Denied Toast
//
// Renders a brief "Access Denied" notification when a user
// is redirected away from a protected route. Reads a
// sessionStorage flag set by AdminGuard on redirect.
// Auto-dismisses after 4 seconds. Pure CSS transition.
// ============================================

import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ShieldX, X } from 'lucide-react';
import { ACCESS_DENIED_KEY } from '../admin/AdminGuard';

export function AccessDeniedToast() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const flag = sessionStorage.getItem(ACCESS_DENIED_KEY);
    if (!flag) return;

    sessionStorage.removeItem(ACCESS_DENIED_KEY);
    setVisible(true);

    const timer = setTimeout(() => setVisible(false), 4000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '12px 16px',
        background: '#FFFFFF',
        border: '1px solid #E4E4E7',
        borderRadius: 4,
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        fontFamily: "'DM Sans', sans-serif",
        fontSize: 14,
        color: '#18181B',
        animation: 'toast-slide-in 0.25s ease-out',
      }}
    >
      <ShieldX size={18} style={{ color: '#DC2626', flexShrink: 0 }} />
      <span>Access denied. You don't have admin privileges.</span>
      <button
        onClick={() => setVisible(false)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 2,
          marginLeft: 4,
          color: '#A1A1AA',
          display: 'flex',
        }}
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
      <style>{`
        @keyframes toast-slide-in {
          from { opacity: 0; transform: translateY(-12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
